export default "assets/images/icons/blason-0d51a4ea.svg";